export { default as Tooltip } from './component';
